import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, getCurrentInstance } from 'vue'
import { useStore } from '../store/index'
import { ElMessage } from 'element-plus'
import { sendCode } from '@/apis/zone'
import { updateBindPhone } from '../apis/user'
import { isValidTel } from '../utils/validator'
import { UserMutationTypes } from '@/store/modules/user/mutation-types'


export default /*@__PURE__*/_defineComponent({
  __name: 'BindPhoneDialog',
  props: {
    showClose: {
        type: Boolean,
        default: true
    }
},
  setup(__props, { expose: __expose }) {

const store = useStore()
const { proxy } = getCurrentInstance() as any

const props = __props

// 表单数据
const dialogShow = ref<boolean>(false) // 弹框状态
const phone = ref<string>('') // 手机号
const code = ref<string>('') // 验证码
const second = ref<number>(0) // 倒计时
// 打开弹框
const openDialog = () => {
    dialogShow.value = true
}
// 发送验证码
const onSend = () => {
    if (!isValidTel(phone.value)) {
        return proxy.$message({ type: 'error', message: '请输入有效手机号' })
    }
    sendCode(phone.value).then((res:any) => {
        const { code, data, msg } = res
        if (code != 200) { return ElMessage({ type: 'error', message: msg }) }
        doCountDown() // 开始倒计时
    })
}
// 倒计时
const doCountDown = () => {
    second.value = 60
    const timer = setInterval(() => {
        second.value > 0 ? second.value-- : clearInterval(timer)
    }, 1000)
}
// 绑定
const onBind = async () => {
    if (!isValidTel(phone.value)) {
        return ElMessage({ type: 'error', message: '请输入有效手机号' })
    }
    if (!code.value) {
        return ElMessage({ type: 'error', message: '请输入验证码' })
    }
    const { code:resCode, data, msg } = await updateBindPhone(phone.value, code.value) as any
    if (resCode != 200) { return ElMessage({ type: 'error', message: msg }) }
    ElMessage({ type: 'success', message: '操作成功' })
    dialogShow.value = false
    updateUserInfo(phone.value)
}

// 更新 vuex
const updateUserInfo = (phone:any) => {
    const userInfo = store.state.user.userInfo
    userInfo.phone = phone
    store.commit(UserMutationTypes.SET_USERINFO, userInfo)
}

// 暴露方法
__expose({
    openDialog
})

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    title: "绑定手机号",
    modelValue: dialogShow.value,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((dialogShow).value = $event)),
    "show-close": __props.showClose,
    "close-on-click-modal": __props.showClose
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        type: "primary",
        onClick: onBind
      }, {
        default: _withCtx(() => _cache[5] || (_cache[5] = [
          _createTextVNode("确定")
        ])),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      _cache[6] || (_cache[6] = _createElementVNode("div", { class: "msg" }, "商家您好：鉴于日后将对后台进行优化，为了能够提供更好的服务体验、设置电话提醒等功能，请各位配合填写电话号码，十分感谢", -1)),
      _createVNode(_component_el_form, { ref: "dialogForm" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, {
            label: "手机号",
            prop: "phone"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: phone.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((phone).value = $event)),
                modelModifiers: { trim: true },
                placeholder: "输入手机号",
                clearable: "",
                maxlength: "11",
                onInput: _cache[1] || (_cache[1] = ($event: any) => (phone.value = phone.value.replace(/[^0-9]/g,''))),
                style: {"width":"200px","margin-right":"10px"}
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "验证码",
            prop: "code"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: code.value,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((code).value = $event)),
                    modelModifiers: { trim: true },
                    placeholder: "输入验证码",
                    maxlength: "6",
                    onInput: _cache[3] || (_cache[3] = ($event: any) => (code.value = code.value.replace(/[^0-9]/g,''))),
                    style: {"width":"200px","margin-right":"10px"}
                  }, null, 8, ["modelValue"]),
                  _createVNode(_component_el_button, {
                    type: "danger",
                    disabled: second.value > 0,
                    onClick: onSend
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(second.value > 0 ? second.value : '获取验证码'), 1)
                    ]),
                    _: 1
                  }, 8, ["disabled"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 512)
    ]),
    _: 1
  }, 8, ["modelValue", "show-close", "close-on-click-modal"]))
}
}

})